<template>
  <!-- Not `.sidebar`: that class belongs to the *left* region and carries a
       `border-right`, which on this region painted a 1px hairline down the
       right edge of the viewport, plus a `$palette-neutral-25` fill the panel
       inside it then covered anyway. This region owns only the flex column its
       panels stack in; each panel paints its own surface and leading edge. -->
  <div class="right-sidebar">
    <component
      :is="component"
      v-for="(component, index) in sidebarWorkspaceComponents"
      :key="'sidebarWorkspaceComponents' + index"
      :workspace="workspace"
    ></component>
  </div>
</template>

<script>
export default {
  name: 'RightSidebar',
  // No `width` prop: width is region geometry and the region owner sets it on
  // the `.layout__col-3` wrapper. A panel that could set its own width would
  // resize a region it shares with every other panel in it.
  props: {
    workspace: {
      type: Object,
      required: true,
    },
  },
  computed: {
    sidebarWorkspaceComponents() {
      return Object.values(this.$registry.getAll('plugin'))
        .flatMap((plugin) =>
          plugin.getRightSidebarWorkspaceComponents(this.workspace)
        )
        .filter((component) => component !== null)
    },
  },
}
</script>
